import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { trackPage } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const suggestionsCache = {};

export const resetSuggestions = () => ({ type: types.RESET_SUGGESTIONS });

export const showSuggestions = () => ({ type: types.SHOW_SUGGESTIONS });

export function requestSuggestions(text) {
  return {
    type: types.REQUEST_SUGGESTIONS,
    payload: { text },
  };
}

export function receiveSuggestions(query, autoComplete) {
  return {
    type: types.RECEIVE_SUGGESTIONS,
    payload: { query, autoComplete },
  };
}

export function receiveSuggestionsError() {
  return {
    type: types.RECEIVE_SUGGESTIONS_ERROR,
  };
}

export function updateSuggestionsFromCache(query, autoComplete) {
  return {
    type: types.UPDATE_SUGGESTIONS_FROM_CACHE,
    payload: { query, autoComplete },
  };
}

export function getSuggestions(query) {
  return (dispatch) => {
    dispatch(requestSuggestions(query));
    const url = `/smarthelp/km-search-auto-complete?q=${query}`;
    return axios.get(url)
      .then((response) => {
        const { autoComplete } = response.data;
        if (autoComplete.length) {
          suggestionsCache[query] = autoComplete; // update the cache
        } else {
          trackPage({ id: `searchAutoCompleteEmptyResult${Page.getFPTIPageId()}`, link: 'smarthelp-selected-suggested-keyword-km-auto-complete-no-result', srch: query });
        }
        dispatch(receiveSuggestions(query, autoComplete));
      })
      .catch(() => {
        trackPage({ id: `searchAutoCompleteError${Page.getFPTIPageId()}`, link: 'smarthelp-selected-suggested-keyword-km-auto-complete-error-response', srch: query });
        dispatch(receiveSuggestionsError());
      });
  };
}

export const clearSuggestions = () => (dispatch) => {
  dispatch(resetSuggestions());
};

export const enableSuggestions = () => (dispatch) => {
  dispatch(showSuggestions());
};

export default function updateSuggestions(query) {
  return (dispatch) => {
    if (query in suggestionsCache) {
      dispatch(updateSuggestionsFromCache(query, suggestionsCache[query]));
    } else {
      dispatch(getSuggestions(query));
    }
  };
}
